import {
	getUsersList,
	getByUsersName,
	getByUsersEmail,
	getByUsersActaId,
	postListFromUser,
	deleteListFromUser,
	getListFromUser

} from '@/api/Erp'

export default {

	async getUsers(payload) {
		try {
			const response = await getUsersList.get({
				uriParams: {
					page: payload.page,
					size: payload.size,
				},
				headers: {
					'Authorization': `Bearer ${payload.token}`
				}
			})
			return response
		} catch (error) {
			return error.response
		}
	},
	async getUsersActaId(payload) {
		try {
			const response = await getByUsersActaId.get({
				uriParams: {
					search: payload.search,
				},
				headers: {
					'Authorization': `Bearer ${payload.token}`
				}
			})
			return response
		} catch (error) {
			return error.response
		}
	},
	async getUsersEmail(payload) {
		try {
			const response = await getByUsersEmail.get({
				uriParams: {
					page: payload.page,
					size: payload.size,
					search: payload.search,
				},
				headers: {
					'Authorization': `Bearer ${payload.token}`
				}
			})
			return response
		} catch (error) {
			return error.response
		}
	},
	async getUsersName(payload) {
		try {
			const response = await getByUsersName.get({
				uriParams: {
					page: payload.page,
					size: payload.size,
					search: payload.search,
				},
				headers: {
					'Authorization': `Bearer ${payload.token}`
				}
			})
			return response
		} catch (error) {
			return error.response
		}
	},
	async postListFromUser(payload) {
		try {
			const response = await postListFromUser.post(
				{},
				{
					uriParams: {
						id_group: payload.id_group,
						acta_user_id : payload.acta_user_id
					},
					headers: {
						'Authorization': `Bearer ${payload.token}`
					},
				}
			)
			return response
		} catch (error) {
			return error.response
		}
	},
	async deleteListFromUser(payload) {
		try {
			const response = await deleteListFromUser.delete({
				uriParams: {
					id_group: payload.id_group,
					acta_user_id : payload.acta_user_id
				},
				headers: {
					'Authorization': `Bearer ${payload.token}`
				}
			})
			return response
		} catch (error) {
			return error.response
		}
	},
	async getListFromUser(payload) {
		try {
			const response = await getListFromUser.get({
				uriParams: {
					acta_user_id : payload.acta_user_id
				},
				headers: {
					'Authorization': `Bearer ${payload.token}`
				}
			})
			return response
		} catch (error) {
			return error.response
		}
	},
   }






// WEBPACK FOOTER //
// ./src/store/modules/user_management/resources.js